// extracted by mini-css-extract-plugin
export default {"steps":"EditingCoursePage_steps__C-EfV","number":"EditingCoursePage_number__JhDZA","active":"EditingCoursePage_active__6o7Qx","done":"EditingCoursePage_done__IoYVs"};